import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/services/auth.service/auth.service";
import { UserService } from "src/app/services/uppy/user.service";
import { IdleTimeoutService } from "../../services/idle-timeout-service/idle-timeout.service";
import { ConfirmationCloseDialogComponent } from "../confirmation-close-dialog/confirmation-close-dialog.component";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'app-session-timeout',
    templateUrl: './session-timeout.component.html',
    styleUrls: ['./session-timeout.component.scss'],
    standalone: false
})
export class SessionTimeoutComponent implements OnInit {
  private _idleTimerSubscription: Subscription;
  currentLang: string = ''
  dialogRef

  constructor(public translateService: TranslateService,
    public changeRef: ChangeDetectorRef,
    public dialog: MatDialog,
    public route: ActivatedRoute,
    @Inject('IdleTimeoutService') public idleTimeoutSvc: IdleTimeoutService,
    @Inject('AuthService') public authService: AuthService,
    @Inject('UserService') public userService: UserService,
  ) {
    this.currentLang = translateService.currentLang
    this._idleTimerSubscription = this.idleTimeoutSvc.timeoutExpired.subscribe(() => {
    })
  }

  ngOnInit(): void {
    if (this.authService.isSessionExpiryValid()) this.evaluatingTimer();

    this.authService.newExpirationSet.subscribe(isNew => {
      if (isNew) {
        this.evaluatingTimer();
      } else
        this.idleTimeoutSvc.stopTimer();
    });
  }

  private evaluatingTimer() {
    //@ts-ignore
    let isTPAuthPage = this.route.snapshot && this.route.snapshot.children.length > 0 && this.route.snapshot.children[0].routeConfig.path == 'training-provider'
    if (isTPAuthPage) {

      this.idleTimeoutSvc.startTimer();
      this._idleTimerSubscription = this.idleTimeoutSvc.timeoutExpired.subscribe(res => {

        var accessAllowed = this.authService.isSessionExpiryValid();
        if (accessAllowed == true) {
          var minutesToExpire = this.authService.sessionToExpireWithinTime();
          if (minutesToExpire <= 10)  //expire within 10 minutes
          {
            minutesToExpire = minutesToExpire == null || minutesToExpire <= 0 ? 0 : minutesToExpire
            this.showDialogForExtendSession(minutesToExpire);
          }
        }
      });
    }
  }

  public showDialogForExtendSession(mins: number) {
    try {
      this.dialog.closeAll();
    } catch (e) {
    }

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;

    dialogConfig.data =
    {
      mins: mins,
      inactive: 30 - mins
    };

    this.dialogRef = this.dialog.open(ConfirmationCloseDialogComponent, dialogConfig);

    this.dialogRef.afterClosed().subscribe
      (
        data => {
          if (data === true) {
            this.idleTimeoutSvc.resetTimer();
            this.changeRef.markForCheck();
            this.userService.GetCurrentUser().subscribe(data => { })
          } else if (data === false) {
            this.changeRef.markForCheck()
            this.authService.goToLogout()
          }
        }
      );
  }
}
